import React, { useState, useEffect } from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Divider, Grid, IconButton, Typography, useTheme, styled, FormGroup, List, ListItem, useMediaQuery } from '@mui/material';
import HDNotificationBanner from '../hd-ui-kit/HDNotificationBanner';
import HDDropDown from '../hd-ui-kit/HDDropDown';
import { HDRadio } from '../hd-ui-kit/HDRadio';
import HDButton from '../hd-ui-kit/HDButton';
import Api from '../Api';
import Loader from '../commons/Loader';
import HDSpinner from '../hd-ui-kit/HDSpinner';
import { validateFields, validationOptions } from '../ValidationSchema';

const RoleSelection = (props: any) => {
  const isDarkTheme = useTheme().palette.mode === 'dark';
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [industryRadio, setIndustryRadio] = useState(false);
  const [functionRadio, setFunctionRadio] = useState(false);
  const [dropdDownList, setDropdDownList] = useState<any>([]);
  const [subDropdDownList, setSubDropdDownList] = useState<any>([]);
  const [roleDropDownList, setRoleDropDownList] = useState<any>([]);
  const [selectedDropOption, setSelectedDropOption] = useState<any>();
  const [selectedSubDropOption, setSelectedSubDropOption] = useState<any>();
  const [selectedRoleData, setSelectedRoleData] = useState<any>();
  const [functionsDropdownList, setFunctionsDropdownList] = useState<any>([]);
  const [industryDropdownList, setIndustryDropdownList] = useState<any>([]);
  const [errorText, setErrorText] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const [, setError] = useState<boolean>(false);
  const [showRoleLoader, setShowRoleLoader] = useState<boolean>(false);
  const [disableOtherField, setDisableOtherField] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [apiErrorText, setApiErrorText] = useState<string>();

  const isLoadingWithRoleDataOnMobile = loading && selectedRoleData && isMobile;
  const isLoadingWithRoleDataOnDesktop = loading && selectedRoleData && !isMobile;
  const widthValue = isLoadingWithRoleDataOnMobile  ? '87%' : undefined

  const sxFormTitleSection = { display: 'flex', justifyContent: 'space-between', alignItems: 'center' };

  const StyledSelectText = styled(Typography)(() => ({
    fontFamily: 'Aventa',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '31px',
    lineHeight: '41px',
    color: isDarkTheme ? '#FFFFFF' : '#002136',
  }));

  const StyledSubText = styled(Typography)(() => ({
    fontFamily: 'Avenir',
    fontStyle: 'normal',
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '24px',
    color: isDarkTheme ? '#FFFFFF' : '#334255',
    marginTop: '15px',
    marginBottom: '15px',
  }));

  const StyledDividerSmall = styled(Divider)(() => ({
    color: isDarkTheme ? '#66FCFC' : '#18768C',
    marginTop: '8px',
    marginBottom: '6px',
    width: '4%',
    backgroundColor: isDarkTheme ? '#66FCFC' : '#18768C',
  }));

  const MainBox = styled(Box)(() => ({
    width: '100%',
  }));

  const StyledListItem = styled(ListItem)(() => ({
    display: 'block',
    paddingTop: '0px',
    paddingLeft: '0px',
    paddingRight: '0px',
  }));

  const StyledDropDownOptions = styled(Box)(() => ({
    paddingTop: '20px',
  }));

  const StyledBox = {
    display: 'block',
    width: '100%',
    background: '#18768C',
    borderRadius: '6px',
    color: '#fff',
    padding: '8px 0px',
    flexDirection: 'row !important',
  };

  const StyleBoxMargin = { marginBottom: '22px' };

  const StyledRadio = {
    fontFamily: 'Aventa',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '24px',
    color: isDarkTheme ? '#FFFFFF' : '#002136',
  };

  const StyledLoadingBox = { display: 'flex', marginTop: '25px', width: '100%' };
  const StyledSpinnerBox = { marginTop: '10px', marginLeft: '150px' };

  const errorMsgStyle = {
    color: '#cc33a1',
    fontFamily: 'Avenir',
    fontSize: '16px',
    marginBottom: '20px',
  };

  const loaderStyle = {
    position: !isMobile || (isMobile && loading && selectedRoleData) ? 'absolute' : '',
    width: isLoadingWithRoleDataOnDesktop ? '92%' : widthValue,
  };

  useEffect(() => {
    setLoading(true);
    Api.getLookupData()
      .then((response: any) => {
        if (response?.success) {
          const filteredFunctionsData = response?.response?.data?.functions?.filter((item: any) => {
            return item?.isEnabled && item.isEnabled === true;
          });
          const functionsDropdown = listPrepared(filteredFunctionsData);
          setFunctionsDropdownList(functionsDropdown);

          const industrySectorObj = response?.response?.data?.lookUpTypes?.find((obj: any) => obj.lookupName === 'Industry Sector');

          const industryDropdown = industrySectorObj.lookupValues?.filter((item: any) => {
            return item?.isEnabled && item.isEnabled === true;
          });

          const industrySubSectorObj = response?.response?.data?.lookUpTypes?.find((obj: any) => obj.lookupName === 'Industry Sub Sector');
          industryDropdown.forEach((parentItem: any) => {
            const subIndustry = industrySubSectorObj?.lookupValues?.filter((sub: any) => sub.parent === parentItem.fieldValue);
            parentItem.subIndustry = subIndustry;
          });
          const industryListDropdown = listPrepared(industryDropdown);
          setIndustryDropdownList(industryListDropdown);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const listPrepared = (item: any) => {
    const listWithSelect = item?.map((i: any) => {
      return {
        label: i.fieldValue,
        value: i.id,
        subList: subListPrepared(i),
      };
    });
    listWithSelect.unshift({ label: 'Select', value: '' });
    return listWithSelect;
  };

  const subListPrepared = (i: any) => {
    if (i?.subIndustry) {
      if (i?.subIndustry && i?.subIndustry?.length > 0) {
        const filteredSubList = i?.subIndustry?.filter((item: any) => {
          return item.isEnabled && item.isEnabled === true;
        });
        const subList = filteredSubList?.map((list: any) => {
          return {
            label: list.fieldValue,
            value: list.code,
            assessmentStructureId: list?.assessmentStructureId ? list.assessmentStructureId : null,
          };
        });
        subList.unshift({ label: 'Select', value: '' });
        return subList;
      }
    } else {
      if (i?.subFunctions && i?.subFunctions?.length > 0) {
        const filteredSubList = i?.subFunctions?.filter((item: any) => {
          return item.isEnabled && item.isEnabled === true;
        });
        const subList = filteredSubList?.map((list: any) => {
          return {
            label: list.fieldValue,
            value: list.code,
          };
        });
        subList.unshift({ label: 'Select', value: '' });
        return subList;
      }
    }
  };

  const radioSelection = (name: any) => {
    props?.setSelectedRoleType(name);
    setSelectedDropOption(null);
    setSelectedSubDropOption(null);
    setSelectedRoleData(null);
    setRoleDropDownList([]);
    setErrorText('');
    setApiErrorText('');
    if (name === 'industry') {
      setIndustryRadio(true);
      setFunctionRadio(false);
      setDropdDownList(industryDropdownList);
    } else {
      setIndustryRadio(false);
      setFunctionRadio(true);
      setDropdDownList(functionsDropdownList);
    }
  };

  const onChangeDropDown = (e: any) => {
    setSelectedDropOption(e);
    setSelectedSubDropOption(null);
    setSelectedRoleData('');
    setErrorText('');
    setApiErrorText('');
    setRoleDropDownList([]);
    if (e !== null || e !== undefined) {
      if (e?.value !== '') {
        setSubDropdDownList(e?.subList);
      } else {
        setSubDropdDownList([]);
      }
    }
  };

  const handleRoleApiErrorPart = () => {
    setRoleDropDownList([]);
    setErrorText(`We don't have any roles associated with that function.
    Please select another function.`);
    setShowRoleLoader(false);
    setDisableOtherField(false);
    setError(true);
  };

  const handleSubDropdownOption = (e: any) => {
    setDisableOtherField(true);
    setSelectedSubDropOption(e);
    setSelectedRoleData('');
    setRoleDropDownList([]);
    setShowRoleLoader(true);
    setApiErrorText('');
    if (e?.assessmentStructureId) {
      props?.setAssessmentStructureId(e.assessmentStructureId);
    }
    if (e !== null && e !== undefined && e?.value !== '' && e?.label !== 'Select') {
      Api.getRolesByFunctionsIndustry(props?.selectedRoleType, e?.value)
        .then((response: any) => {
          if (response?.success) {
            const roleList: any = response?.response?.data?.map((list: any) => {
              return {
                label: list.name,
                id: list.id,
              };
            });
            roleList.unshift({ label: 'Select', id: '' });
            setDisableOtherField(false);

            if (roleList.length) {
              setRoleDropDownList(roleList);
              setShowRoleLoader(false);
              setError(false);
            } else {
              handleRoleApiErrorPart();
            }
          } else {
            handleRoleApiErrorPart();
          }
        })
        .catch((err) => {
          console.error('Error fetching roles:', err);
        });
    } else {
      setRoleDropDownList([]);
      setShowRoleLoader(false);
      return;
    }
  };

  const handleChangeRole = (e: any) => {
    setSelectedRoleData(e);
    setApiErrorText('');
  };

  const handleConfirmRole = () => {
    setErrors({});
    const parentDropdownOptionMsg = validateFields.validate({ dropDown: selectedDropOption.id }, validationOptions)?.error?.details[0]?.message;
    const subDropdownOptionMsg = validateFields.validate({ dropDown: selectedSubDropOption.id }, validationOptions)?.error?.details[0]?.message;
    const selectedRoleDataMsg = validateFields.validate({ dropDown: selectedRoleData.id }, validationOptions)?.error?.details[0]?.message;
    if (parentDropdownOptionMsg || subDropdownOptionMsg || selectedRoleDataMsg) {
      setErrors({
        selectedDropOption: parentDropdownOptionMsg,
        selectedSubDropOption: subDropdownOptionMsg,
        selectedRoleData: selectedRoleDataMsg,
      });
      return;
    }
    setLoading(true);

    let payload = {
      clientName: 'Edge',
      businessRoleID: selectedRoleData.id,
      businessRole: {
        name: selectedRoleData.label,
        id: selectedRoleData.id,
      },

      path_selected: props?.selectedRoleType,
      ...(props?.selectedRoleType === 'function' && {
        businessFunction: {
          name: selectedDropOption.label,
          id: selectedDropOption.value,
        },
        businessSubFunction: {
          name: selectedSubDropOption.label,
          id: selectedSubDropOption.value,
        },
      }),
      ...(props?.selectedRoleType === 'industry' && {
        industrySector: {
          name: selectedDropOption.label,
          id: selectedDropOption.value,
        },
        industrySubSector: {
          name: selectedSubDropOption.label,
          id: selectedSubDropOption.value,
        },
      }),
    };

    Api.postSelectedRole(payload)
      .then((res: any) => {
        if (res && res.success) {
          setLoading(false);
          props?.setOpen(false);
          setApiErrorText('');
          props?.setLoader(false);
          props?.setBusinessRoleId(selectedRoleData);
          props?.setSelectedRoleType(props?.selectedRoleType);
        } else {
          props?.setOpen(true);
          setLoading(false);
          setApiErrorText('Something went wrong. Please try again later.');
        }
      })
      .catch((err) => {});
  };

  const roleDropDownColor = selectedDropOption && selectedSubDropOption && selectedRoleData ? '#66FCFC' : '#A9A9A9';
  const renderRoleDropdown = () => {
    if (roleDropDownList && roleDropDownList.length > 0) {
      return (
        <Box sx={StyleBoxMargin}>
          <HDDropDown
            toolTipPlacement="right"
            labelColor={isDarkTheme ? '#FFFFFF !important' : '#334255 !important'}
            showToolTip={true}
            toolTipText="The specific position or job title within an organization that outlines responsibilities, decision-making scope, and leadership impact. (Ex: VP of Financial Planning & Analysis)"
            isAutoComplete={true}
            value={selectedRoleData}
            fieldLabel="Select a Role"
            placeHolder="Select"
            autoCompleteOptions={roleDropDownList}
            fullWidth={true}
            disabled={!selectedSubDropOption}
            error={errors?.selectedRoleData}
            errorMsg={errors?.selectedRoleData || null}
            defaultValue=""
            onChange={(e) => handleChangeRole(e)}
          />
        </Box>
      );
    } else if (showRoleLoader) {
      return (
        <Box sx={StyledLoadingBox}>
          <Box sx={StyledSpinnerBox}>
            <HDSpinner size="la-sm" />
          </Box>
        </Box>
      );
    } else if (errorText) {
      return <Box sx={errorMsgStyle}>{errorText}</Box>;
    }

    return null;
  };

  return (
    <Box sx={loaderStyle}>
      {loading && <Loader sx={{ position: 'absolute' }} />}

      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <StyledSelectText>{'Select a target role'}</StyledSelectText>
        <Box sx={sxFormTitleSection}>
          <IconButton
            onClick={() => {
              props?.setOpen(false);
              props?.setLoader(false);
            }}
          >
            <img alt="Close modal" src={window.location.origin + '/res/hd-ui-kit-images/' + (isDarkTheme ? 'close-dark.svg' : 'close.svg')} />
          </IconButton>
        </Box>
      </Box>

      <StyledDividerSmall />
      <StyledSubText>In your reports, we'll show the benchmarks for this role — so you can see how you compare.</StyledSubText>

      <MainBox>
        <HDNotificationBanner StyledParentBox={StyledBox} content="This role cannot be changed once you start an assessment." variant="filled" severity="info" />
      </MainBox>

      <StyledDropDownOptions>
        <FormGroup>
          <List>
            <StyledListItem>
              <HDRadio sx={StyledRadio} name="JobFunction" label="Start by selecting a job function" checked={functionRadio} hasError={false} onChange={() => radioSelection('function')} showBackground={true} disabled={disableOtherField ? true : false} />
            </StyledListItem>
            <StyledListItem>
              <HDRadio sx={StyledRadio} name="industry" label="Start by selecting an industry" checked={industryRadio} hasError={false} onChange={() => radioSelection('industry')} showBackground={true} disabled={disableOtherField ? true : false} />
            </StyledListItem>
          </List>
        </FormGroup>
        <Grid container>
          <Grid item xs={12} md={6} lg={6} pt={2}>
            {functionRadio || industryRadio ? (
              <>
                <Box sx={StyleBoxMargin}>
                  <HDDropDown
                    toolTipPlacement={'right'}
                    labelColor={isDarkTheme ? '#FFFFFF !important' : '#334255 !important'}
                    showToolTip={true}
                    toolTipText={functionRadio ? 'A distinct area of expertise and focus within an organization. (ex: Finance)' : 'A group of companies, organizations, or businesses that engage in similar types of economic activities. (Ex: Financial Services)'}
                    isAutoComplete={true}
                    value={selectedDropOption}
                    fieldLabel={industryRadio ? 'Select a Industry Sector' : 'Select a Job Function'}
                    placeHolder={'Select'}
                    autoCompleteOptions={dropdDownList}
                    fullWidth={true}
                    error={errors?.selectedDropOption}
                    errorMsg={errors?.selectedDropOption ? errors.selectedDropOption : null}
                    defaultValue="Select"
                    onChange={(e) => {
                      onChangeDropDown(e);
                    }}
                    readOnly={!disableOtherField ? false : true}
                  />
                </Box>
                <Box sx={StyleBoxMargin}>
                  <HDDropDown
                    toolTipPlacement={'right'}
                    labelColor={isDarkTheme ? '#FFFFFF !important' : '#334255 !important'}
                    showToolTip={true}
                    toolTipText={
                      functionRadio
                        ? 'A more specific area of expertise within a larger functional area. Categorizes responsibilities and tasks within a function. (Ex: Financial Planning & Analysis)'
                        : 'A specialized category of economic activity within a particular industry. Reflects narrower areas of specialization, market focus, or distinct product/service offerings. (Ex: Banking)'
                    }
                    isAutoComplete={true}
                    value={selectedSubDropOption}
                    fieldLabel={industryRadio ? 'Select a Industry Sub-sector' : 'Select a Sub-function'}
                    placeHolder={'Select'}
                    autoCompleteOptions={subDropdDownList}
                    fullWidth={true}
                    disabled={selectedDropOption ? false : true}
                    error={errors?.selectedSubDropOption}
                    errorMsg={errors?.selectedSubDropOption ? errors.selectedSubDropOption : null}
                    defaultValue=""
                    onChange={(e) => {
                      handleSubDropdownOption(e);
                    }}
                  />
                </Box>
              </>
            ) : (
              <></>
            )}
            {renderRoleDropdown()}
            <Box sx={errorMsgStyle}>{apiErrorText}</Box>

            <Box sx={{ paddingTop: '25px' }}>
              <HDButton
                text={'Confirm Role'}
                onClick={() => {
                  handleConfirmRole();
                }}
                variant={'contained'}
                size={'medium'}
                endIcon={<ArrowForwardIcon sx={{ color: isDarkTheme ? '#18768C' : roleDropDownColor }} />}
                disabled={selectedDropOption && selectedSubDropOption && selectedRoleData ? false : true}
                disableRipple={true}
              />
            </Box>
          </Grid>
        </Grid>
      </StyledDropDownOptions>
    </Box>
  );
};

export default RoleSelection;
